/**
 * Utilitários para tradução de status e termos em inglês
 */

/**
 * Traduz status de campanhas para português
 * @param {string} status - Status em inglês
 * @returns {string} Status traduzido
 */
export function translateCampaignStatus(status) {
  const translations = {
    'completed': 'Concluída',
    'active': 'Ativa',
    'stopped': 'Parada',
    'paused': 'Pausada',
    'pending': 'Pendente',
    'failed': 'Falhou',
    'running': 'Executando',
    'cancelled': 'Cancelada',
    'draft': 'Rascunho'
  };
  
  return translations[status] || status;
}

/**
 * Traduz status de contatos para português
 * @param {string} status - Status em inglês
 * @returns {string} Status traduzido
 */
export function translateContactStatus(status) {
  const translations = {
    'active': 'Ativo',
    'inactive': 'Inativo',
    'blocked': 'Bloqueado',
    'ignored': 'Ignorado',
    'lead': 'Lead',
    'client': 'Cliente',
    'prospect': 'Prospecto'
  };
  
  return translations[status] || status;
}

/**
 * Traduz status de mensagens para português
 * @param {string} status - Status em inglês
 * @returns {string} Status traduzido
 */
export function translateMessageStatus(status) {
  const translations = {
    'sent': 'Enviada',
    'delivered': 'Entregue',
    'read': 'Lida',
    'failed': 'Falhou',
    'pending': 'Pendente',
    'queued': 'Na fila'
  };
  
  return translations[status] || status;
}

/**
 * Traduz termos gerais do sistema para português
 * @param {string} term - Termo em inglês
 * @returns {string} Termo traduzido
 */
export function translateGeneralTerm(term) {
  const translations = {
    'loading': 'Carregando',
    'error': 'Erro',
    'success': 'Sucesso',
    'warning': 'Aviso',
    'info': 'Informação',
    'cancel': 'Cancelar',
    'confirm': 'Confirmar',
    'delete': 'Excluir',
    'edit': 'Editar',
    'save': 'Salvar',
    'close': 'Fechar',
    'open': 'Abrir',
    'view': 'Visualizar',
    'download': 'Baixar',
    'upload': 'Enviar',
    'search': 'Buscar',
    'filter': 'Filtrar',
    'sort': 'Ordenar',
    'export': 'Exportar',
    'import': 'Importar'
  };
  
  return translations[term] || term;
}